import { FILTER_QUERIES } from '../../models/filters';

const queryKeys = {
  SEARCH: {
    sessionId: 'SessionId',
    transportKey: 'TransportKey',
    transportId: 'TransportId',
    bookingEngineKey: 'StrBookingEngineKey',
    isStandalone: 'IsStandalone',
    sortKey: 'sortKey',
    accomodationKey: 'AccBookKey',
    roomGroupKey: 'RoomGroupKey',
    categoryId: 'CategoryId',
    tdmRuleId: 'TdmRuleId',
    selectedHotelCode: 'SelectedHotelCode',
    price: 'Price',
    hotelId: 'HotelId',
    bestPrice: 'BestPrice',
    accomodationKeys: 'AccomodationKeys',
    sequence: 'Sequence',
    tripRuleId: 'TripRuleId',
    selectedCabin: 'SelectedCabin',
    tags: 'tags',
    recommended: 'recommended',
    cruiseCode: 'CruiseCode',
    cruiseId: 'CruiseId',
    changeCabin: 'ChangeCabin',
    fastestFlight: 'FastestFlight',
    tripContext: 'TripContext',
    cabinClass: 'CabinClass',
    directFlight: 'DirectFlight',
    includeBaggage: 'IncludeBaggage',
  },

  QUERY: {
    departureId: 'QueryDepID',
    departureWvId: 'QueryDepWvID',
    departureCode: 'QueryDepCD',
    departureDate: 'QueryDepDate',
    returnDate: 'QueryRetDate',
    duration: 'QueryDur',
    roomDistribution: 'QueryRoomAges',
    ages: 'QueryAges',
    resortId: 'QueryResID',
    resortWvId: 'QueryResWvID',
    areaId: 'QueryAreaID',
    countryId: 'QueryCtryID',
    destinationAirportId: 'QueryDestID',
    adults: 'QueryAdults',
    childrenAges: 'QueryChildrenAges',
  },
  FILTER: FILTER_QUERIES,
  SCROLL_POSITION: 'scrollPosition',
  CRUISE_FILTERS: {
    departureMonth: 'f_depmonth',
    shipRating: 'f_rating',
    duration: 'f_dur',
    cruiseCategory: 'f_cat',
    destination: 'f_dest',
    numberOfDestinations: 'f_ndest',
    shippingCompany: 'f_company',
  },
};

export default queryKeys;
